import Folder, {FolderTypeEnum} from '../domain/Folder';
import {ExpandedFolderIdPref, SearchOptionsPref} from '../util/Preferences';
import {EmailHeader} from '../services/messages/EmailHeaderDto';
import {OutgoingEmailDto} from '../services/messages/OutgoingEmailDto';
import SearchOptions from "../domain/SearchOptions";
import {IDatasource} from "ag-grid-community/dist/types/src/interfaces/iDatasource";

export interface FolderState {
    folderList: Folder[];

    outgoingEmails: OutgoingEmailDto[];

    expandedFolderIds: number[];
    selectedFolderId?: number;
    selectedFolder?: Folder;

    searchText: string;
    notesSearchText: string;
    searchOptions: SearchOptions;
    currentSearchText?: string;
    searchInProgress: boolean;

    contextFolder?: Folder;

    folderSelectionMode?: "email" | "folder";
    editingFolder: Folder;
    emailsToMove: EmailHeader[];
    showEditFolderDialog: boolean;

    lazyLoadDataSource?: IDatasource;
}

export const FolderTemplate: Folder = {type: FolderTypeEnum.UserMail, folderId: -1, hidden: false, parentId: "0", icon: "", indent: 0, name: "", serverId: "", unreadCount: 0};

export const initialFolderState: FolderState = {
    folderList: [],

    outgoingEmails: [],

    expandedFolderIds: ExpandedFolderIdPref.get(),
    searchText: "",
    notesSearchText: "",
    searchOptions: SearchOptionsPref.get(),
    searchInProgress: false,

    editingFolder: FolderTemplate,
    showEditFolderDialog: false,
    emailsToMove: [],
};
